import React from 'react';
import * as XLSX from 'xlsx';
import styled from 'styled-components';
import Excelicon from '../images/excelicon.png';
import { CommonButton } from '../Styles/CommonStyles';

const ExcelImage = styled.img`
  width: 50px;
  cursor: pointer;
  margin-right: 10px;
`;

const SubmitButton = styled(CommonButton)`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const ExcelDownload = ({ data, filename, sheetName, button }) => {
  console.log(data)
  const addSerialNumber = (data) => {
    return data?.map((row, index) => {
      return { 'S.No.': index + 1, ...row };
    });
  };

  const downloadExcel = () => {
    let dataToExport = addSerialNumber(data);

    // Remove "S.No." when button is true
    if (button) {
      dataToExport = dataToExport.map(({ "S.No.": _, ...rest }) => rest);
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || 'Sheet1');
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };

  return button ? (
    <SubmitButton type="button" onClick={downloadExcel}>
      Download Excel Upload Format
    </SubmitButton>
  ) : (
    <ExcelImage src={Excelicon} onClick={downloadExcel} />
  );
};

export default ExcelDownload;
